import { Component, Input, inject } from '@angular/core';
import { ICONS } from '../../../core/enum/icon-constants';
import { IconComponent } from "../../icon/icon.component";
import {SimulationDrawClassesService} from "../../../services/simulation/simulation-draw-classes.service";
import { CommonModule } from '@angular/common';
import { ExplorerMapService } from '../../../services/explorer-map.service';

@Component({
  selector: 'app-simulation-popup',
  standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './simulation-popup.component.html',
  styleUrl: './simulation-popup.component.scss'
})
export class SimulationPopupComponent {
  protected readonly ICONS = ICONS;
  @Input() featureProperties: {[key: string]: any};
  @Input() geometryType!: string;
  @Input() areaInKm2!: number | null;
  @Input() centroid!: [number, number];
  @Input() featureIndex!: number;
  @Input() isNewlyDrawn: boolean = false;
  @Input() isEditing: boolean = false; 

  private explorerMapService: ExplorerMapService = inject(ExplorerMapService);
  private simulationDrawClassesService: SimulationDrawClassesService = inject(SimulationDrawClassesService);


  ngOnInit(): void {

  }
  getInterventionDetails(): { imagePath: string, label: string } {
  const intervention = this.featureProperties?.['properties']?.['intervention'];

  const basePath = 'assets/pictures/interventions';

  const map: Record<number, { imagePath: string, label: string }> = {
    1: { imagePath: `${basePath}/building_bricks.webp`, label: 'Building Brick' },
    2: { imagePath: `${basePath}/building_cool_roof.webp`, label: 'Building Cool Roof' },
    3: { imagePath: `${basePath}/building_concrete.webp`, label: 'Building Concrete' },
    4: { imagePath: `${basePath}/street.webp`, label: 'Street' },
    5: { imagePath: `${basePath}/grassland.webp`, label: 'Grassland' },
    6: { imagePath: `${basePath}/little_trees.webp`, label: 'Small Tree' },
    7: { imagePath: `${basePath}/metium_trees.webp`, label: 'Medium Tree' },
    8: { imagePath: `${basePath}/big_trees.webp`, label: 'Big Tree' },
    9: { imagePath: `${basePath}/baresoil.webp`, label: 'Baresoil' },
    10: { imagePath: `${basePath}/cropland.webp`, label: 'Cropland' },
    11: { imagePath: `${basePath}/water.webp`, label: 'Water' },
  };

  return map[intervention] ?? {
    imagePath: `${basePath}/unknown.webp`,
    label: 'Unknown'
  };
}

  deleteDraw() {
    const featureId = this.featureProperties?.["id"];
    if(!featureId) return;
    this.simulationDrawClassesService.deleteDrawSimulation(featureId);
  }
}
